(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
	typeof define === 'function' && define.amd ? define(factory) :
	(global.luett = factory());
}(this, (function () { 'use strict';

function toArray(iterable) {
  return [].slice.call(iterable);
}

function mapCall(list, action) {
  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  return list.map(function (item) {
    return action.apply(undefined, [item].concat(args));
  });
}

var util = { toArray: toArray, mapCall: mapCall };

function $(selector) {
  var el = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document;

  return el.querySelector(selector);
}

function $$(selector) {
  var el = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document;

  return toArray(el.querySelectorAll(selector));
}

function id(name) {
  return document.getElementById(name);
}

function replace(oldElement, newElement) {
  oldElement.parentNode.replaceChild(newElement, oldElement);
  return newElement;
}

function index(el) {
  var idx = 0;
  while (el) {
    idx++;
    el = el.previousElementSibling;
  }
  return idx;
}

function remove(el) {
  el.parentNode && el.parentNode.removeChild(el);
  return el;
}

function rect(el) {
  var rect = el.getBoundingClientRect();

  return {
    top: window.pageYOffset + rect.top,
    left: window.pageXOffset + rect.left,
    width: rect.width,
    height: rect.height
  };
}

function className(name) {
  var _this = this;

  return {
    add: function add(el) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      addClass.apply(undefined, [el].concat(args.concat(name)));
      return _this;
    },
    remove: function remove(el) {
      for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }

      removeClass.apply(undefined, [el].concat(args.concat(name)));
      return _this;
    },
    toggle: function toggle(el) {
      var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

      toggleClass(el, name, force);
      return _this;
    },
    has: function has(el) {
      return el.classList.contains(name);
    },
    selector: function selector() {
      return '.' + name;
    },
    toString: function toString() {
      return name;
    }
  };
}

function addClass(el) {
  var _el$classList;

  for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    args[_key3 - 1] = arguments[_key3];
  }

  (_el$classList = el.classList).add.apply(_el$classList, args);
  return el;
}

function toggleClass(el, className) {
  var force = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;

  el.classList.toggle(className, force);
  return el;
}

function removeClass(el) {
  var _el$classList2;

  for (var _len4 = arguments.length, args = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
    args[_key4 - 1] = arguments[_key4];
  }

  (_el$classList2 = el.classList).remove.apply(_el$classList2, args);
  return el;
}

var attr$ = function attr$($) {
  return function () {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
    var el = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document;

    if (value instanceof window.HTMLElement) {
      el = value;
      value = undefined;
    }
    return $(this.selector(value), el);
  };
};

function attr(name) {
  var _attr = {
    get: function get(el) {
      for (var _len5 = arguments.length, args = Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
        args[_key5 - 1] = arguments[_key5];
      }

      return getAttr.apply(undefined, [el, name].concat(args));
    },
    set: function set(el) {
      for (var _len6 = arguments.length, args = Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
        args[_key6 - 1] = arguments[_key6];
      }

      setAttr.apply(undefined, [el, name].concat(args));
      return _attr;
    },
    remove: function remove(el) {
      el.removeAttribute(name);
      return _attr;
    },
    has: function has(el) {
      return hasAttr(el, name);
    },
    selector: function selector() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
      return '[' + name + (value ? '="' + value + '"' : '') + ']';
    },
    toString: function toString() {
      return name;
    },
    $: attr$($),
    $$: attr$($$)
  };
  return _attr;
}

function getAttr(el, name) {
  var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;

  return el && el.hasAttribute(name) ? el.getAttribute(name) : defaultValue;
}

function setAttr(el, name, value) {
  var append = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  var attrValue = append ? getAttr(el, name, '') + ' ' + value : value;
  el.setAttribute(name, attrValue);
  return el;
}

function hasAttr(el, name) {
  return el && el.hasAttribute(name);
}

function insertElement(position, node, newNode) {
  switch (position) {
    case 'beforebegin':
      node.parentNode.insertBefore(newNode, node);
      break;
    case 'afterend':
      node.parentNode.insertBefore(newNode, node.nextElementSibling);
      break;
  }

  return newNode;
}

insertElement.before = function (node, newNode) {
  return insertElement('beforebegin', node, newNode);
};
insertElement.after = function (node, newNode) {
  return insertElement('afterend', node, newNode);
};

var dom = {
  $: $,
  $$: $$,
  id: id,
  replace: replace,
  index: index,
  remove: remove,
  rect: rect,
  className: className,
  addClass: addClass,
  toggleClass: toggleClass,
  removeClass: removeClass,
  attr: attr,
  getAttr: getAttr,
  setAttr: setAttr,
  hasAttr: hasAttr,
  insertElement: insertElement
};

function delay(time, value) {
  return new Promise(function (resolve) {
    setTimeout(function () {
      return resolve(value);
    }, time);
  });
}

delay.pass = function (time) {
  return function (value) {
    return delay(time, value);
  };
};

var promise = { delay: delay };

var DEFAULT_KEY_MODIFIERS = { shiftKey: false, ctrlKey: false, altKey: false };

function keyPressed(keyCode, modifiers, callback) {
  if (typeof modifiers === 'function') {
    callback = modifiers;
    modifiers = Object.assign({}, DEFAULT_KEY_MODIFIERS);
  } else {
    modifiers = Object.assign({}, DEFAULT_KEY_MODIFIERS, modifiers);
  }

  return function (event) {
    // proper event?
    if (!event) {
      return;
    }
    // correct keyCode?
    if (event.keyCode !== keyCode) {
      return;
    }

    // correct modifiers?
    if (Object.keys(modifiers).reduce(function (result, name) {
      return result && event[name] === modifiers[name];
    }, true) !== true) {
      return;
    }

    callback.apply(this, arguments);
  };
}

keyPressed.return = keyPressed.bind(null, 13);

function matchesMedia(query, matchesCallback, notMatchesCallback) {
  return function () {
    if (window.matchMedia(query).matches) {
      matchesCallback.apply(this, arguments);
    } else {
      if (notMatchesCallback) {
        notMatchesCallback.apply(this, arguments);
      }
    }
  };
}

matchesMedia.min = {};
matchesMedia.min.small = matchesMedia.bind(null, '(min-width: 768px)');
matchesMedia.min.medium = matchesMedia.bind(null, '(min-width: 992px)');
matchesMedia.min.large = matchesMedia.bind(null, '(min-width: 1200px)');
matchesMedia.min.hd = matchesMedia.bind(null, '(min-width: 1920px)');
matchesMedia.max = {};
matchesMedia.max.small = matchesMedia.bind(null, '(max-width: 767px)');
matchesMedia.max.medium = matchesMedia.bind(null, '(max-width: 991px)');
matchesMedia.max.large = matchesMedia.bind(null, '(max-width: 1199px)');
matchesMedia.max.hd = matchesMedia.bind(null, '(max-width: 1919px)');

function on(el, event, callback) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  var events = typeof event === 'string' ? [event] : event;
  events.forEach(function (event) {
    return el.addEventListener(event, callback, options);
  });
  return {
    destroy: function destroy() {
      events.forEach(function (event) {
        return el.removeEventListener(event, callback, options);
      });
    }
  };
}

var event = { keyPressed: keyPressed, matchesMedia: matchesMedia, on: on };

function upperFirst(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

function parseConfig(el, name) {
  var confMatcher = new RegExp('data-(?:component|' + name + ')-(.+)', 'i');
  var defaultConf = {};

  toArray(el.attributes).forEach(function (attr$$1) {
    var match = confMatcher.exec(attr$$1.name);

    if (confMatcher.test(attr$$1.name)) {
      var _name = match[1].split('-').reduce(function (name, part, idx) {
        return name + (idx > 0 ? upperFirst(part) : part);
      }, '');
      defaultConf[_name] = attr$$1.value;
    }
  });

  try {
    var conf = JSON.parse(el.getAttribute('data-component-conf'));
    return Object.assign(defaultConf, conf);
  } catch (e) {
    return defaultConf;
  }
}

function transformArgs(name, init, opts) {
  opts = opts instanceof window.HTMLElement ? { root: opts } : opts;
  var elements = void 0;

  if (name instanceof window.NodeList) {
    name = toArray(name);
  }

  if (Array.isArray(name)) {
    elements = name;
    name = opts.name || init.NAME;

    if (!name) {
      throw Error('provide component name via factory NAME or name option when passing NodeList/Array');
    }
  } else {
    elements = $$('[data-component~="' + name + '"]:not([data-component-ready~="' + name + '"])', opts.root || document);
  }

  return [elements, name, init, opts];
}

function component(componentName, componentInit) {
  var componentOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var _transformArgs = transformArgs(componentName, componentInit, componentOptions),
      elements = _transformArgs[0],
      name = _transformArgs[1],
      init = _transformArgs[2],
      opts = _transformArgs[3];

  return elements.map(function (el, index$$1) {
    var def = (el.dataset.component || '').split(' ');
    var conf = Object.assign({}, init.DEFAULTS || {}, opts.conf || {}, parseConfig(el, name));
    var componentPrefix = name + '-';

    var options = {
      index: index$$1,
      conf: conf,
      types: def.filter(function (name) {
        return name.indexOf(componentPrefix) === 0;
      }).map(function (name) {
        return name.substr(componentPrefix.length);
      })
    };

    var component = init(el, options);
    setAttr(el, 'data-component-ready', name, true);
    return component;
  });
}

var component$1 = { component: component };

var main = Object.assign(dom, event, promise, util, component$1);

return main;

})));
